import { useEffect } from "react";

const RedirectToInsurance = () => {
    useEffect(() => {
        window.location.replace("https://elevatecoachingrei.steadilypartner.com/");
    }, []);

    return null;
};

export default RedirectToInsurance;